module.exports = __webpack_public_path__ + "static/media/centralised_management.9aa8fd77.webp";